import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=54f1d865&scoped=true"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropDown.vue?vue&type=style&index=0&id=54f1d865&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1d865",
  null
  
)

export default component.exports